import { useMemo, useState } from 'react';

import { SortingState } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

import { DataTable } from '@/components/ui/table/data-table';
import useMembers from '@/hooks/useMembers';

import { createColumns } from './columns';
import { Credential } from '../../types';

interface APIKeysTableProps {
  credentials: Credential[];
  isLoading: boolean;
  canDelete: boolean;
  onDelete: (credential: Credential, onSettled: () => void) => void;
}

export const APIKeysTable = ({
  credentials,
  isLoading,
  canDelete,
  onDelete,
}: APIKeysTableProps) => {
  const { t } = useTranslation();
  const { getMember } = useMembers();
  const [sorting, setSorting] = useState<SortingState>([{ id: 'created', desc: true }]);

  const columns = useMemo(
    () => createColumns({ onDelete, getMember, canDelete }),
    [onDelete, getMember, canDelete]
  );

  return (
    <DataTable.Root
      fill
      className="min-h-0 flex-1"
      columns={columns}
      data={credentials}
      rowCount={credentials.length}
      isLoading={isLoading}
      resourceName="api-keys"
      sorting={sorting}
      onSortingChange={setSorting}
      emptyStateMessage={t('developer_tools.api_keys_no_results')}
      getRowId={(row) => row.credential_id}
      autoResetPageIndex
    >
      <DataTable.Content />
      <DataTable.Pagination />
    </DataTable.Root>
  );
};
